/* eslint-disable react/require-default-props, react/no-unused-prop-types */
import React from 'react';
import { MultiSelectBase } from '../MultiSelectBase';
/**
 * MultiSelectFilter
 * Multi-select popup filter with search. Plain option rendering.
 * Parity with legacy `MultiSelect.jsx`.
 * @version 1.0.0
 * @since 2026-05-04
 */
export function MultiSelectFilter({ label, value, onChange, options, placeholder, disabled, showReset }) {
    return (React.createElement(MultiSelectBase, { label: label, value: value, onChange: onChange, options: options, placeholder: placeholder, disabled: disabled, showReset: showReset }));
}
